module.exports = __webpack_public_path__ + "site_static/img/channel2.d1b0e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channel2.png
// module id = CJD8
// module chunks = 0